import {throwError as observableThrowError,  Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Location } from '../models/location.model';
import { Log } from '../utils/log';
import { Utils } from '../utils/utils';
import { DaySlots } from '../models/schedule/day-slots.model';
import { Slot } from '../models/schedule/slot.model';
import { DaySlotsHash } from '../models/schedule/day-slots-hash.interface';
import { Url } from '../models/url/url.model';
import { UrlParam } from '../models/url/url-param.model';
import { UrlParams } from '../models/url/url-params.model';
import { SessionService } from './session.service';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable()
export class ScheduleService {

    constructor(private http: HttpClient, private session: SessionService) {}

    /**
     * getScheduleSlots
     * @param location
     * @param startTime
     * @param endTime
     */
    public getScheduleSlots(location: Location, startTime?:Date, endTime?:Date, service?:string):Observable<DaySlotsHash> {

        let params:UrlParams = new UrlParams();
        let startTimeParam: UrlParam;
        let endTimeParam: UrlParam;

        if(startTime) {
            startTime = Utils.getCleanDate(startTime);
        } else {
            startTime = Utils.getCleanDate(new Date());
        }

        startTimeParam = new UrlParam('startTimestamp', Utils.getLocalISOTimeDateString(startTime));
        params.add(startTimeParam);

        if(endTime) {
            endTime = Utils.getCleanDate(endTime);
        } else {
            endTime = Utils.getCleanDate(new Date());
        }

        endTime = Utils.getCleanDate(Utils.getFutureDay(endTime, 1));

        endTimeParam = new UrlParam('endTimestamp', Utils.getLocalISOTimeDateString(endTime));
        params.add(endTimeParam);

        let url:Url;

        if (environment.useStaticAPIData) {
            url = new Url('getAllScheduleSlotsForLocation.json');
        } else {

            if (location.id === environment.REMOTE_LOCATION_ID) {
                const tzParam = new UrlParam('tzData', location.tzData);
                params.add(tzParam);

                if (service) {
                    params.add(new UrlParam('serviceName', service));
                }

                url = new Url('remote/slots', params);
            } else {
                url = new Url('locations/' + location.id + '/slots', params);
            }
        }

        // Initially token may not be available or from external
        const options = {
            headers: new HttpHeaders({
            'Authorization': this.session.token || ''
            })
        };

        return this.http.get(url.toString(), options).pipe(
                map((res:any) => {
                     if (res) {

                        let slots: Slot[] = new Array<Slot>();
                        res.forEach((slot: any) => {
                            slots.push(new Slot(slot));
                        });
                        let returnObj: DaySlotsHash = {};
                        slots.forEach((slot: Slot) => {
                            let slotDate = Utils.getShortISOYearMonthDay(slot.date);
                            if (!returnObj[slotDate]) {
                                returnObj[slotDate] = new DaySlots();
                                returnObj[slotDate].date = slotDate;
                                returnObj[slotDate].addSlot(slot);
                            } else {
                                returnObj[slotDate].addSlot(slot);
                            }

                        });
                        for (let key in returnObj) {
                            returnObj[key].sortSlots();
                        }
                        return returnObj;

                    } else {
                        Log.error('Error occured when getting schedules for a location: response null');
                        return null;
                    }
                }, catchError(this.handleError))
        );
    }

    private handleError(error: any) {
        let errMsg = '';
        if (error.message) {
            errMsg = error.message;
        } else if (error.status) {
            if (error.statusText) {
                errMsg = `${error.status} - ${error.statusText}`;
            } else {
                errMsg = 'Server error';
            }
        } else {
            errMsg = 'Server error';
        }

        return observableThrowError(errMsg);
    }

}
